'use strict'

module.exports = collapse

// `collapse(' \t\nbar \nbaz\t') // ' bar baz '`
function collapse(value) {
  return String(value).replace(/\s+/g, ' ')
}



//////////////////
// WEBPACK FOOTER
// ./~/collapse-white-space/index.js
// module id = 208
// module chunks = 104158497352714 142496547410815 230539012308250